import { useEffect, useState } from 'react';

import { Box, Stack, Typography } from '@mui/material';

function formatUtcDateTime(now: Date): string {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'UTC',
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(now);

  const get = (type: Intl.DateTimeFormatPartTypes): string =>
    parts.find((part) => part.type === type)?.value ?? '';

  return `${get('weekday')}, ${get('day')} ${get('month')} ${get('year')} ${get('hour')}:${get('minute')}:${get('second')}`;
}

/** Current UTC clock — advanced cron editor uses UTC wall clock only. */
export const UtcTimeDisplay = () => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const intervalId = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <Box
      sx={{
        px: 2,
        py: 1.5,
        borderRadius: 1,
        bgcolor: 'grey.50',
        border: 1,
        borderColor: 'divider',
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        sx={{ mb: 0.5 }}
      >
        <Typography variant="caption" color="text.secondary" fontWeight={600}>
          UTC Time
        </Typography>
        <Typography variant="caption" color="text.secondary" fontWeight={600}>
          UTC
        </Typography>
      </Stack>
      <Typography variant="body2" fontWeight={600} sx={{ fontVariantNumeric: 'tabular-nums' }}>
        {formatUtcDateTime(now)}
      </Typography>
    </Box>
  );
};
